<template>
  <div id="left-nav-list-main-container">
    <v-list v-if="listItems" dense expand class="pa-0 text-subtitle-2 font-weight-bold">

      <template v-for="item in listItems">
        <template v-if="item.childModules.length">

          <v-list-group :key="item.uid"
            :append-icon="item.childModules.length ? 'fa-angle-down' : ''" class="pa-0">
            <template v-slot:activator>
              <app-tooltip transition="slide-x-transition" right open-delay="750" close-delay="0" :containerClass="'full-width d-flex'">
                <v-list-item :to="item.route" class="pa-0">
                  <v-list-item-action class="pa-0">
                    <v-icon :color="item.colorHex" :class="getGroupItemCss(item)">{{ item.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content class="pa-0">
                    <v-list-item-title class="text-subtitle-2 font-weight-bold">
                      <span class="mr-1">{{ $t(item.name) }}</span>
                      <b v-if="item.moduleType === ModuleTypes.Agree && agreesUnreadCounter"> {{'(' + agreesUnreadCounter + ')'}} </b>
                      <b v-if="item.moduleType === ModuleTypes.DocumentsAll && documentsUnreadCounter">{{'('+documentsUnreadCounter+')'}}</b>
                      <b v-if="item.moduleType === ModuleTypes.Signs && signsUnreadCounter"> {{'(' + signsUnreadCounter + ')'}} </b>
                      <b v-if="item.moduleType === ModuleTypes.Acquaint && acquaintsUnreadCounter">{{'(' + acquaintsUnreadCounter + ')'}}</b>
                      <b v-if="item.moduleType === ModuleTypes.AllProcessed && processedDocumentsUnreadCounter">{{'(' + processedDocumentsUnreadCounter + ')'}}</b>
                      <b v-if="item.moduleType === ModuleTypes.Favorites && favoritesDocumentsUnreadCounter">{{'(' + favoritesDocumentsUnreadCounter + ')'}}</b>
                      <b v-if="item.moduleType === ModuleTypes.Archive && archivedDocumentsUnreadCounter">{{'(' + archivedDocumentsUnreadCounter + ')'}}</b>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <template v-slot:tooltip> {{ $t(item.hint) }}</template>
              </app-tooltip>
            </template>

            <app-tooltip v-for="(child) in item.childModules" :key="child.uid" transition="slide-x-transition" right open-delay="750"
              close-delay="0" :containerClass="'d-flex'">

              <v-list-item :to="child.route" class="ie-flex-align-items">
                <v-list-item-action class="pa-0 ml-4">
                  <v-icon :color="child.colorHex" :class="getChildItemCss(child)">{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content class="pa-0 text-no-wrap text-truncate text-subtitle-2">
                  {{ child.moduleType === ModuleTypes.Folder ? child.name : $t(child.name) }}
                </v-list-item-content>
              </v-list-item>

              <template v-slot:tooltip> {{ child.moduleType === ModuleTypes.Folder ? child.hint : $t(child.hint) }}</template>
            </app-tooltip>

          </v-list-group>
        </template>

        <template v-else>
          <app-tooltip :key="item.uid" transition="slide-x-transition" right open-delay="750" close-delay="0" :containerClass="'d-flex'">

            <v-list-item :to="item.route" class="align-center ie-flex-align-items"
              :style="{'margin-bottom': item.moduleType===200 ? '8px' : '0px', 'margin-top': item.moduleType===200 ? '8px' : '0px'}">
              <v-list-item-action class="pa-0">
                <v-icon :color="item.colorHex" :class="getItemCss(item)">{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content class="pa-0">
                <v-layout>
                  <span class="mr-1">{{ $t(item.name) }}</span>
                  <b v-if="item.moduleType === ModuleTypes.Agree && agreesUnreadCounter"> {{'(' + agreesUnreadCounter + ')'}} </b>
                  <b v-if="item.moduleType === ModuleTypes.DocumentsAll && documentsUnreadCounter">{{'('+documentsUnreadCounter+')'}}</b>
                  <b v-if="item.moduleType === ModuleTypes.Signs && signsUnreadCounter"> {{'(' + signsUnreadCounter + ')'}} </b>
                  <b v-if="item.moduleType === ModuleTypes.Acquaint && acquaintsUnreadCounter"> {{'(' + acquaintsUnreadCounter + ')'}}</b>
                  <b v-if="item.moduleType === ModuleTypes.AllProcessed && processedDocumentsUnreadCounter">{{'(' + processedDocumentsUnreadCounter + ')'}}</b>
                  <b v-if="item.moduleType === ModuleTypes.Favorites && favoritesDocumentsUnreadCounter">{{'(' + favoritesDocumentsUnreadCounter + ')'}}</b>
                  <b v-if="item.moduleType === ModuleTypes.Archive && archivedDocumentsUnreadCounter">{{'(' + archivedDocumentsUnreadCounter + ')'}}</b>
                </v-layout>
              </v-list-item-content>
            </v-list-item>

            <template v-slot:tooltip>{{ $t(item.hint) }}</template>
          </app-tooltip>
        </template>

      </template>

    </v-list>
  </div>
</template>

<script>
import AppTooltip from '@/components/Common/AppTooltip';

import { eModuleTypes } from '@/models/enums';
import { actions as _act } from '@/models/store.actions';

export default {
  name: 'LeftNavList',
  components: { AppTooltip },
  props: { listItems: undefined },
  data: function() {
    return {};
  },
  computed: {
    acquaintsUnreadCounter() {
      return this.counters ? this.counters.acquaintUnread : 0;
    },
    agreesUnreadCounter() {
      return this.counters ? this.counters.agreeUnread : 0;
    },
    counters() {
      return this.$store.getters[_act.DOC_GET_COUNTERS];
    },
    documentsUnreadCounter() {
      return this.counters ? this.counters.allUnread : 0;
    },
    favoritesDocumentsUnreadCounter() {
      return this.counters ? this.counters.favoritesUnread : 0;
    },
    processedDocumentsUnreadCounter() {
      return this.counters ? this.counters.processedUnread : 0;
    },
    archivedDocumentsUnreadCounter() {
      return this.counters ? this.counters.archiveUnread : 0;
    },
    ModuleTypes() {
      return eModuleTypes;
    },
    signsUnreadCounter() {
      return this.counters ? this.counters.signUnread : 0;
    },
    currentRoutePath() {
      return this.$route.path;
    }
  },
  mounted() {},
  methods: {
    getItemCss(item) {
      let css = '';
      if (
        (item.route &&
          (this.currentRoutePath === item.route ||
          this.currentRoutePath.indexOf(item.route) === 0)) ||
        (item.subModules &&
          item.subModules.length &&
          item.subModules.some(child => child.route === this.currentRoutePath))
      ) {
        css = 'active';
      }
      return css;
    },
    getChildItemCss(item) {
      return this.currentRoutePath.indexOf(item.route) === 0 ? 'active' : '';
    },
    getGroupItemCss(item) {
      let css = '';
      if ((item.route && this.currentRoutePath === item.route) ||
            (item.childModules &&
            item.childModules.length &&
            item.childModules.some(child => this.currentRoutePath.indexOf(child.route) === 0))) {
        css = 'active';
      }
      return css;
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';

#left-nav-list-main-container {
  .v-list-item {
    .v-list-item__action .v-icon {
      color: var(--v-secondary-base);
      &.active {
        color: var(--v-primary-base);
      }
    }
    &:hover .v-list-item__action .v-icon {
      color: var(--v-primary-base);
    }
  }
}
</style>
